import { styled, Typography } from "@mui/material";

export const Title = styled(Typography)(() => ({
  fontFamily: 'MuseoSans',
}));

export const Description = styled(Typography)(() => ({
  marginTop: '10px'
}));

export const pageContainerStyles = { px: { sx: '16px', sm: '16px', md: '30px' } };
export const pageGridTitleStyles = { position: 'relative', height: { md: '55px' } };
export const pageTitleStyles = { position: { md: 'absolute' }, zIndex: { md: 1200 }, top: { md: '-30px' }, marginBottom: { xs: '35px', md: 0 }, marginTop: { xs: '20px', md: 0 }};
export const pageGridDescriptionStyles = { marginTop: '-50px', marginBottom: '35px' };
